module.exports = __webpack_public_path__ + "img/icon-permisos.256103af.svg";